export interface IWellSpec {
  _id?: string;
  company?: string;
  density?: string;
  depth?: string;
  fluid_type?: string;
  inc?: string;
  location?: string;
  rig_type?: string;
  temp_f?: string;
  well_name?: string;
}

export class WellsSpec implements IWellSpec {
  _id?: string;
  company: string;
  density: string;
  depth: string;
  fluid_type: string;
  inc: string;
  location: string;
  rig_type: string;
  temp_f: string;
  well_name: string;

  constructor( wellSpec: IWellSpec = {} ) {
    this._id = wellSpec._id;
    this.company = wellSpec.company;
    this.density = wellSpec.density;
    this.depth = wellSpec.depth;
    this.fluid_type = wellSpec.fluid_type;
    this.inc = wellSpec.inc;
    this.location = wellSpec.location;
    this.rig_type = wellSpec.rig_type;
    this.temp_f = wellSpec.temp_f;
    this.well_name = wellSpec.well_name;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/wells-spec.ts